
<template>
  <div class="grid md:flex">
    <div :class="'w-full sm:w-full ' + `${ sendButton ? 'md:w-10/12' : '' }`">
      <vue-tags-input
        v-model="tag"
        :tags.sync="tags"
        :autocomplete-items="autocompleteItems"
        :placeholder="placeholderText"
        :separators="[';', ' ', '\n', ',']"
        :add-only-from-autocomplete="false"
        @tags-changed="tagsChanged"
        :validation="validation"
        class="overflow-auto w-full"/>
      <span
        class="text-danger text-sm"
        :hidden="!(tags.length > 0 && !tagsValid)"
        v-show="(tags.length > 0 && !tagsValid)">
        {{ $t('messages.add_email_valid') }}
      </span>
    </div>
    <div v-if="sendButton" class="w-full sm:w-full md:w-2/12 flex justify-end sm:justify-end md:justify-start ml-0 md:ml-4 mt-2 md:mt-0">
      <div>
        <vs-button
          type="filled"
          @click="handleSend"
          :disabled="tags.length === 0 || !tagsValid"
        >{{sendText}}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'

export default{
  props: {
    genericProp: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: 'Adicionar e-mails'
    },
    sendText: {
      type: String,
      default: 'Adicionar'
    },
    validationText: {
      type: String,
      default: 'Adicione somente e-mails válidos.'
    },
    sendButton: {
      type: Boolean,
      default: true
    },
    sendButtonHandle: {
      type: Function,
      default: null
    },
    autocompleteItems: {
      type: Array,
      default: () => { return [] }
    },
    emailsInput: {
      type: Array,
      default: () => { return null }
    },
    validation: {
      type: Array,
      default() {
        return [
          {
            classes: 'valid-email-or-user',
            rule: ({ text }) => {
              return !this.$utils.validation.email(text)
            }
          }
        ]
      }
    }
  },

  components: {
    VueTagsInput
  },
  data () {
    return {
      tags: [],
      tag: '',
      tagsValid: false
    }
  },
   watch: {
    tag(value) {
      this.$emit('tagInput', value)
    },
    emailsInput: {
      immediate: true,
      handler (newVal, oldVal) {
       this.tags = this.normalizeTagEmails(newVal)
       this.validateTags()
       this.tagsChanged(this.tags)
      }
    },
  },
  computed: {

  },
  methods: {
    validateTags() {
      for (let index = 0; index < this.tags.length; index++) {
        const tag = this.tags[index]
        for (let index = 0; index < tag.tiClasses.length; index++) {
          const element = tag.tiClasses[index]
          if (element === 'ti-invalid') {
            this.tagsValid = false
            return
          }
        }
      }
      this.tagsValid = true
    },
    colorizeValidTags() {
      this.tags.forEach((tag, index) => {
        if (tag.tiClasses.find(element => element === 'ti-valid')) {
          this.tags[index].classes = 'bg-success'
        }
      })
    },
    tagsChanged(newTags) {
      this.autocompleteItems = []
      this.tags = newTags
      this.validateTags()
      this.colorizeValidTags()
      this.$emit('tagsChanged', this.tags, this.tagsValid)
      this.$emit('emailsChanged', this.handlingEmailsValid(newTags)) //Only valid
    },
    handleSend() {
      if (this.sendButtonHandle === null) {
        this.$emit('tagsSent', this.tags)
      } else {
        this.sendButtonHandle(this.tags)
      }
    },
    handlingEmailsValid(tags){
      let emails = [];
      tags.forEach((tag, index) => {
        if (tag.tiClasses.find(element => element === 'ti-valid')) {
          emails.push(tag.text)
        }
      })
      return emails
    },
    clear() {
      this.tags = []
    },
    normalizeTagEmails(emails){
      let tags = []

      if(emails){
        emails.forEach(email => {
          tags.push({
            'text': email,
            tiClasses: ['ti-valid'],
            classes: 'bg-primary'
          })
        })
      }

      return tags
    }
  },
  beforeMount() {

  },
  mounted() {

  },
  created(){

  }

}
</script>

<style scoped>
  .vue-tags-input {
    max-width: 100% !important;
  }

</style>
